import type { GuidedTourUpdate } from 'src/apis/authorization-service/types';
import type { GuidedTourRequest } from 'src/apis/authorization-service/use-guided-tour';
import { useAxios, type Successful } from 'src/hooks/use-axios';
import { isConstraintViolation } from 'src/utils/is-constraint-violation';

export function useGuidedTourUpdate(guidedTour: Successful<GuidedTourRequest>) {
  return useAxios(
    (axios, baseConfig) => {
      const url = guidedTour.response.data._links.update.href;
      const data: GuidedTourUpdate = {
        tourState: 'FINISHED',
      };
      return axios.request({
        method: 'PUT',
        ...baseConfig,
        url,
        data,
      });
    },

    {
      neededOnPageLoad: false,
      onError(error) {
        if (isConstraintViolation(error)) return error;
        throw error;
      },
    }
  );
}

export type GuidedTourUpdateRequest = ReturnType<typeof useGuidedTourUpdate>;
